import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/occasion-reminders")({
  component: lazyRouteComponent(() => import("./-pages/admin.occasion-reminders")),
  head: () => ({ meta: [{ title: "تذكيرات المناسبات — Lecmo Admin" }] }),
});
